module.exports = __webpack_public_path__ + "static/media/businessman.8e9bccfa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/businessman.svg
// module id = 1082
// module chunks = 2